import { render } from "./ActivityModal.vue?vue&type=template&id=e67163b2&scoped=true"
import script from "./ActivityModal.vue?vue&type=script&lang=js"
export * from "./ActivityModal.vue?vue&type=script&lang=js"

import "./ActivityModal.vue?vue&type=style&index=0&id=e67163b2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67163b2"]])

export default __exports__